"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryTaxonomyLoader = void 0;
const taxonomy_1 = require("src/taxonomy");
class CountryTaxonomyLoader {
    constructor() {
        this.alreadyProcessed = false;
    }
    getTaxonomy(taxonomies) {
        // countriesTaxonomyPlaceholder coming from Umbraco Taxonomy API
        if (!this.countryService) {
            // tslint:disable-next-line:no-console
            console.warn('[CountryTaxonomyLoader] Trying to load countries taxonomy without country service');
            return Promise.resolve(null);
        }
        const countriesTaxonomy = taxonomy_1.TaxonomyService.getTaxonomyGroupByType(taxonomy_1.TaxonomyTypeEnum.CountriesTaxonomy, taxonomies);
        if (!countriesTaxonomy) {
            return Promise.resolve(null);
        }
        return this.countryService.getDataForSelectOptions().then(countries => {
            this.alreadyProcessed = true;
            // state mutation!
            countriesTaxonomy.items = countries.map(country => {
                return {
                    filterValue: `${countriesTaxonomy.filterValue}=${country.value}`,
                    items: null,
                    title: country.title,
                    value: country.value,
                };
            });
            countriesTaxonomy.updatedWithExternalMapper = true;
            return countriesTaxonomy;
        });
    }
}
const countryTaxonomyLoader = new CountryTaxonomyLoader();
exports.countryTaxonomyLoader = countryTaxonomyLoader;
